import type {
  BoolAttributeFragment,
  DropdownAttributeFragment,
  MultiselectAttributeFragment,
  NumericAttributeFragment,
  PlainTextAttributeFragment,
} from '@/graphql/saleor/api';
import { getTranslatedName } from '@/lib/i18n';
import type { Maybe } from '@/lib/types';

export const getBoolValue = (attribute: Maybe<BoolAttributeFragment>) => {
  const value = attribute?.values?.[0];
  return !!value?.boolean || value?.slug === '1' || value?.slug === 'true';
};

export const getDropdownValue = (
  attribute: Maybe<DropdownAttributeFragment>,
) => {
  const value = attribute?.values?.[0];
  return getTranslatedName('name', value, 'plainText');
};

export const resolveColor = (attribute: Maybe<DropdownAttributeFragment>) => {
  const value = attribute?.values?.[0];
  return {
    cssValue: value?.slug || value?.name?.toLowerCase(),
    displayName: getTranslatedName('name', value, 'plainText'),
  };
};

export const getMultiselectValue = (
  attribute: Maybe<MultiselectAttributeFragment>,
  translate = true,
): string[] => {
  const values = attribute?.values ?? [];
  return values.map((value) =>
    translate ? getTranslatedName('name', value, 'plainText') : value.name,
  );
};

export const getNumericValue = (attribute: Maybe<NumericAttributeFragment>) => {
  const value = attribute?.values?.[0]?.name;
  const unit = attribute?.attribute.unit?.toLowerCase() ?? '';
  return { value, unit };
};

export const getPlainTextValue = (
  attribute: Maybe<PlainTextAttributeFragment>,
) => {
  const value = attribute?.values?.[0];
  return getTranslatedName('plainText', value);
};

export const getNameValue = (attribute: Maybe<DropdownAttributeFragment>) => {
  const value = attribute?.values?.[0];
  return getTranslatedName('name', value);
};
